/* eslint-disable default-param-last */

import {
  LOGIN,
  LOGOUT,
  SAVE_STUDENT,
} from '../actionTypes';

export const sessionInitialState = {
  isLoggedIn: false,
  token: '',
  domain: '',
  isStudent: false,
};

export default function session(state = sessionInitialState, action) {
  switch (action.type) {
    case SAVE_STUDENT:
      return {
        ...state,
        isStudent: action.payload.isStudent,
      };
    case LOGIN:
      return {
        ...state,
        isLoggedIn: true,
        token: action.payload.token,
        domain: action.payload.domain,
        currentEmployeeId: action.payload.currentEmployeeId,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
      };
    default:
      return state;
  }
}
